import instanceAxios from "./axios.instance";
import { BASE_URI } from "~/assets/base";

export const getAllCurrency = async () => {
  const response = await instanceAxios.get(`${BASE_URI}currencies`);

  return response;
};
